export function createPaymentsApi(baseUrl) {
  return {
    payments: {
      getPaymentMethods: `${baseUrl}/v2/payments/stripe/cards/`,
      createCardPayment: `${baseUrl}/v1/payments/stripe/donate/card/`,
      saveNewPaymentMethod: `${baseUrl}/v2/payments/stripe/cards/`,
      setDefaultPaymentMethods: `${baseUrl}/v2/payments/stripe/cards/default/`,
    },
  };
}
